import { releaseBookingReservation } from 'api/experiences'
import {
  getExperienceReservationMetadata,
  isExperienceReservationExpired,
} from 'lib/experiences/experienceReservationUtils'
import { reportClientError } from 'services/errorReportingService'

function releaseActiveExperienceReservation(item: App.Checkout.ExperienceItem): void {
  const metadata = getExperienceReservationMetadata(item)
  if (!metadata?.reservationToken || isExperienceReservationExpired(metadata)) return

  releaseBookingReservation(item.experienceId, metadata.reservationToken).catch(error => {
    reportClientError(error, { context: 'release_experience_reservation', itemId: item.itemId })
  })
}

export function releaseExperienceReservationsFromItems(
  items: Array<App.Checkout.AnyItem | undefined>,
): void {
  items.forEach(item => {
    if (item?.itemType !== 'experience') return

    releaseActiveExperienceReservation(item)
  })
}

export function releaseExperienceReservationOnItemRemove(
  item: App.Checkout.AnyItem | undefined,
): void {
  releaseExperienceReservationsFromItems([item])
}
